import type { AffineEditorContainer } from '@blocksuite/presets';
import { OutlineViewer } from '@blocksuite/presets';
import { useCallback, useRef } from 'react';

import * as styles from './outline-viewer.css';

const HIDE_SIDEBAR_BUTTON_STYLE_ID = 'pique-hide-sidebar-button';

function injectHideSidebarButtonStyle(viewer: OutlineViewer) {
  const shadowRoot = viewer.shadowRoot;
  if (!shadowRoot) return;
  if (shadowRoot.getElementById(HIDE_SIDEBAR_BUTTON_STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = HIDE_SIDEBAR_BUTTON_STYLE_ID;
  style.textContent = `.outline-viewer-header edgeless-tool-icon-button { display: none; }`;
  shadowRoot.append(style);
}

export const EditorOutlineViewer = ({
  editor,
  show,
}: {
  editor: AffineEditorContainer | null;
  show: boolean;
}) => {
  const outlineViewerRef = useRef<OutlineViewer | null>(null);

  const onRefChange = useCallback((container: HTMLDivElement | null) => {
    if (container) {
      if (outlineViewerRef.current === null) {
        console.error('outline viewer should be initialized');
        return;
      }

      container.append(outlineViewerRef.current);
      injectHideSidebarButtonStyle(outlineViewerRef.current);
    }
  }, []);

  if (!editor || !show) return;

  if (!outlineViewerRef.current) {
    outlineViewerRef.current = new OutlineViewer();
  }
  if (outlineViewerRef.current.editor !== editor) {
    outlineViewerRef.current.editor = editor;
  }

  return <div className={styles.root} ref={onRefChange} />;
};
